import { Person } from "..";
import { BaseResource } from "./base.resource";

export function getSecuredResources(permissions: string[]): SecuredResource[] {
  let resourceMap: { [resource: string]: string[] } = {};

  permissions.forEach((permission) => {
    let resourceNameStartIndex = permission.indexOf(".");
    let resourceName = permission.substring(0, resourceNameStartIndex);
    let resourceAccess = permission.substring(resourceNameStartIndex + 1);

    let accessList = resourceMap[resourceName] || (resourceMap[resourceName] = []);
    accessList.push(resourceAccess);
  });

  const resources = Object.keys(resourceMap).map((resource) => {
    return { resourceName: resource, accessList: resourceMap[resource] };
  });

  return resources;
}

export const SecurityAccessLevel = {
  None: 0,
  View: 1 << 0,
  Edit: 1 << 1,
  Delete: 1 << 2,
};

export interface SecuredResource {
  resourceName: string;
  accessList: string[];
}

export class Security extends BaseResource {
  name: string;
  description: string;
  subscriptions: Person[];
  allowedActions: string[];
  notifications: string[];

  constructor(options?: any) {
    super(options);
    this.subscriptions = this.subscriptions || [];
    this.allowedActions = this.allowedActions || [];
    this.notifications = this.notifications || [];
  }

  get securedResources(): SecuredResource[] {
    return getSecuredResources(this.allowedActions);
  }

  get canView(): boolean {
    return (this.accessLevel & SecurityAccessLevel.View) > 0;
  }
  get canEdit(): boolean {
    return (this.accessLevel & SecurityAccessLevel.Edit) > 0;
  }
  get canDelete(): boolean {
    return (this.accessLevel & SecurityAccessLevel.Delete) > 0;
  }
}
